import { Box } from "@chakra-ui/react";
import VmPricingTable from "./vmTable";
import { CLOUD_VM_INTEL_DEDICATED } from "./constants";

const IntelDedicatedPricing = () => {
  return (
    <Box id="intel-based-dedicated-cpu">
      <VmPricingTable {...CLOUD_VM_INTEL_DEDICATED} />
    </Box>
  );
};

export default IntelDedicatedPricing;
